module.exports = __webpack_public_path__ + "static/bulette_pota-e3d78f2caf2aa16a09e7ae26625ce421.webp";